<template>
  <div>
    <div class="label_PFormInputText" v-if="label && showLabel">{{ label }}</div>
    <div class="label_PFormInputText colorTransparente" v-if="!showLabel">.</div>
    <ValidationProvider :rules="rules" v-slot="{ errors }">
      <div class="p_input_group">
        <p-icon :icon="icon" :type="itype" class="p_icon_input_text" size="20" v-if="icon" />
        <input
          :type="type"
          v-model="valueLocal"
          :class="[variantCop, classIcon]"
          :placeholder="placeholderComp"
          @input="input"
          :readonly="readonly"
          :min="min"
          :max="max"
          :step="step"
          v-if="type !== 'textarea'"
        />
        <textarea
          v-model="valueLocal"
          :class="[variantCop, classIcon]"
          :placeholder="placeholderComp"
          @input="input"
          :readonly="readonly"
          :rows="rows"
          cols="50"
          v-if="type === 'textarea'"
        ></textarea>
        <div class="p_form_invalid_feedback" v-if="errors[0] && invalid_feedback">
          {{ invalid_feedback }}
        </div>
        <div class="p_form_invalid_feedback" v-if="errors[0]">
          {{ $t(errors[0]) }}
        </div>
      </div>
    </ValidationProvider>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import PIcon from "../PIcon/PIcon.vue";

@Component({
  components: { PIcon },
})
export class PFormInputText extends Vue {
  @Prop({ required: true }) value!: string;
  @Watch("value", { immediate: true })
  onChangeValue(): void {
    this.valueLocal = this.value;
    this.showLabelVarientLine();
  }
  @Prop({ required: false, default: "text" }) type!: string;
  @Prop({ required: false, default: undefined }) min!: number;
  @Prop({ required: false, default: undefined }) max!: number;
  @Prop({ required: false, default: undefined }) step!: number;
  @Prop({ required: false, default: "" }) placeholder!: string;
  @Prop({ required: false, default: "" }) label!: string;
  @Prop({ required: false, default: false }) readonly!: boolean;
  @Prop({ required: false, default: "primary" }) variant!: string;
  @Prop({ required: false, default: undefined }) rules!: string;
  @Prop({ required: false, default: "" }) invalid_feedback!: string;
  @Prop({ required: false, default: 4 }) rows!: number;
  @Prop({ required: false }) icon!: string;
  @Prop({ required: false, default: "" }) itype!: string;

  valueLocal = "";
  showLabel = false;
  mounted(): void {
    if (this.variant != "line") {
      this.showLabel = true;
    }
  }
  get placeholderComp(): string {
    if (this.variant === "line") {
      return this.label;
    } else {
      return this.placeholder;
    }
  }
  get variantCop(): string {
    return "input_PFormInputText_" + this.variant;
  }
  get classIcon(): string {
    return this.icon ? "icon_PFormInputText_icon" : "";
  }
  showLabelVarientLine(): void {
    if (this.variant === "line") {
      this.showLabel = this.valueLocal != "";
    }
  }
  input(): void {
    this.showLabelVarientLine();
    this.$emit("input", this.valueLocal);
  }
}
export default PFormInputText;
</script>
<style lang="scss" scoped>
.label_PFormInputText {
  line-height: 1.23;
  color: #6f6f6f;
  min-height: 16px;
  padding-bottom: 0.5rem;
  font-size: 12px;
}
.input_PFormInputText_primary:not(textarea) {
  height: 45px;
}
.input_PFormInputText_primary {
  border-radius: 4px;
  border: solid 1px #e4e4e4;
  background-color: #fafafa;
  padding: 12px 10px 12px 10px;
  color: #807f7f;
  width: 100%;
}
.input_PFormInputText_line {
  border-top: 0 !important;
  border-bottom: solid 1px #e4e4e4 !important;
  border-left: 0 !important;
  border-right: 0 !important;
  border-radius: 0 !important;
  width: 100%;
  padding: 10px 10px 12px 10px;
  color: #807f7f;
}
.colorTransparente {
  opacity: 0;
}

.p_form_invalid_feedback {
  color: #dc3545;
  font-size: 0.7rem;
}
.p_input_group {
  position: relative;
}
.p_icon_input_text {
  position: absolute;
  left: 0.5rem;
  top: 12px;
}
.icon_PFormInputText_icon {
  padding-left: 30px;
}
</style>
